/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Inbound/view.blocks to change it.
import Attachments from './Attachments/index'
import CardMessageNoAvatar from 'DesignSystem/CardMessageNoAvatar/index'
import Content from './Content/index'
import Info from './Info/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Inbound({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/EventsTimeline/Content/Event/Types/Sms/Content/Inbound"
  
}) {
  return (<React.Fragment
>
<CardMessageNoAvatar
  viewPath={`${viewPath}/CardMessageNoAvatar`}
 marginLeft={0}
 alignSelf="flex-start"
 backgroundColor="rgba(19,126,197,0.1)"
>
{childProps => (
<React.Fragment>
<Content
{...childProps}
  viewPath={`${viewPath}/Content`}
/>
<Info
{...childProps}
  viewPath={`${viewPath}/Info`}
/>
<Attachments
{...childProps}
  viewPath={`${viewPath}/Attachments`}
/>
</React.Fragment>
)}
</CardMessageNoAvatar>
{children}
</React.Fragment>)
}